import React, { type HTMLProps } from 'react';
import classNames from 'classnames';

import styles from './Table.module.scss';

type Props = HTMLProps<HTMLTableElement> & {
    stickyHeader?: boolean;
    testId?: string;
};

const Table = (props: Props) => {
    const { stickyHeader, className, testId = 'table', ...otherProps } = props;

    const tableClasses = classNames(
        styles.table,
        {
            [styles.tableWithStickyHeader]: stickyHeader,
        },
        className
    );

    return <table className={tableClasses} {...otherProps} data-testid={testId} />;
};

export default Table;
